import { createContext } from 'react'

export const ChangeThresholdReviewContext = createContext({
  newThreshold: 0,
})
